module.exports = __webpack_public_path__ + "494cd07c/img/upload-icon.9179ae4e.svg";